// extracted by mini-css-extract-plugin
export default {"container":"Pagination_container__v+ZAh"};